// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__vlFNt","signatureBlock":"Footer_signatureBlock__n3J84","signature":"Footer_signature__317tJ"};